var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
  padding: _vm.item.level === 0 ? '0 20px' : '0 0px'
})},[_c('div',{staticClass:"name",style:({
    width: _vm.item.children?.length > 1 ? 100 / _vm.item.children.length + 100 / _vm.item.children.length / 2 + '%' : '100%',
  }),attrs:{"_flex":"~ justify-center","_text":"20px bold center"}},[_vm._v(_vm._s(_vm.item.name))]),(_vm.item.children)?_c('div',{attrs:{"_m":"y-10px","_flex":"~"}},_vm._l((_vm.item.children),function(child){return _c('tree-item',{key:child.id,attrs:{"item":child}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }